// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/current/uiwidgets/selected-zones/';
export const actions = [
  'ADD_SELECTED_ZONE',
  'CLEAR_SELECTED_ZONES',
  'REMOVE_SELECTED_ZONE',
  'TOGGLE_SELECTED_ZONE'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});


// Reducer
export default function reducer(
  state = [],
  action = {}
) {
  const _addSelected = (zoneId) => state.includes(zoneId) ? state.slice() : state.concat([zoneId]);
  const _removeSelected = (zoneId) => state.filter((eachZoneId) => eachZoneId !== zoneId);

  switch (action.type) {
    case actions.ADD_SELECTED_ZONE:
      return _addSelected(action.payload.zoneId);

    case actions.REMOVE_SELECTED_ZONE:
      return _removeSelected(action.payload.zoneId);

    case actions.TOGGLE_SELECTED_ZONE:
      return (state.indexOf(action.payload.zoneId) === -1)
        ? _addSelected(action.payload.zoneId) : _removeSelected(action.payload.zoneId);

    case actions.CLEAR_SELECTED_ZONES:
      return [];

    default:
      return state;
  }
}

// Action creators

export const addSelectedZone = (zoneId) => {
  return {
    type: actions.ADD_SELECTED_ZONE,
    payload: { zoneId }
  };
};

export const removeSelectedZone = (zoneId) => {
  return {
    type: actions.REMOVE_SELECTED_ZONE,
    payload: { zoneId }
  };
};

export const toggleSelectedZone = (zoneId) => {
  return {
    type: actions.TOGGLE_SELECTED_ZONE,
    payload: { zoneId }
  };
};

export const clearSelectedZones = () => {
  return {
    type: actions.CLEAR_SELECTED_ZONES
  };
};
